/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Success_Password_ResetInputs */



/**
* | output |
* | --- |
* | "Password reset email sent! Please check your inbox." |
*
* @param {Login_Success_Password_ResetInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_success_password_reset = /** @type {((inputs?: Login_Success_Password_ResetInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Success_Password_ResetInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Email de réinitialisation du mot de passe envoyé ! Veuillez vérifier votre boîte de réception.")
	if (locale === "de") return /** @type {LocalizedString} */ ("E-Mail zum Zurücksetzen des Passworts wurde versendet! Bitte überprüfen Sie Ihren Posteingang.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Email di reimpostazione password inviata! Controlla la tua casella di posta.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Письмо для сброса пароля отправлено! Пожалуйста, проверьте свою почту.")
	if (locale === "es") return /** @type {LocalizedString} */ ("¡Correo electrónico de restablecimiento de contraseña enviado! Por favor, revise su bandeja de entrada.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("密码重置邮件已发送！请查收您的邮箱。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("パスワードリセットメールを送信しました。受信トレイをご確認ください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पासवर्ड रीसेट करने के लिए ईमेल भेजा गया है! कृपया अपना इनबॉक्स देखें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("E-mail de redefinição de senha enviado! Por favor, verifique sua caixa de entrada.")
	return /** @type {LocalizedString} */ ("Password reset email sent! Please check your inbox.")
});